import { Component, OnInit, ɵConsole } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { AuthService } from "../../../../services/auth.service";
import { CommonService } from "../../../../services/common.service";
import { ReservationService } from "../../../../services/reservation.service";
import { FormatterService } from "../../../../services/formatter.service";
import { AppConfig } from "../../../../configs/app";

@Component({
  selector: "page-reservation-detail",
  templateUrl: "./index.component.html",
})
export class PageReservationDetailComponent implements OnInit {
  public moment: any;
  public _: any;
  public $: any;

  public reservationData: any = {};
  public activatedStation: any = {};
  public currentCancelRuleItem: any = {};

  public cancelInformation: any;
  public errorCancelMessage: any;

  public useUnderPrice: any;
  public receiptData: any = {};
  public receiptForm: any = {};
  public receiptFormUnder: any = {};
  public pdfData: any = {};

  public c: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public commonService: CommonService,
    public reservationService: ReservationService,
    public formatterService: FormatterService,
    public appConfig: AppConfig
  ) {
    this.receiptFormUnder = this.formBuilder.group({
      name: ["", Validators.required],
      proviso: ["高速バス代金", Validators.required],
    });

    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.$ = this.commonService.getJQuery();
  }

  async ngOnInit() {
    /* COMMENTED FOR PUBLIC SEARCH CHECK IF NOT LOGGED IN */
    /* if (!this.authService.isLoggedIn()) {
            return this.commonService.redirectToRoute(this.commonService.routePaths.pageHomeNoParam);
        } */

    /* SET PAGE TITLE */
    this.commonService.setTitle(`予約の詳細 | バスブックマーク`);

    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET RESERVATION DATA */
    let reservationData = this.commonService.getData(
      "searchReservationDataDetail"
    );
    if (this._.isEmpty(reservationData)) {
      this.reservationData =
        await this.reservationService.getReservationDetails({
          reservationID:
            this.activatedRoute.snapshot.paramMap.get("reservationID"),
          busDetail: 1,
          emailDetail: 1,
        });
    } else {
      this.reservationData = await this.reservationService.findReservationByID({
        reservationID: reservationData.reservation.reservation_id,
        tel: `${reservationData.userData.tel1}${reservationData.userData.tel2}${reservationData.userData.tel3}`,
        busDetail: 1,
        emailDetail: 1,
      });
    }

    if (
      this._.isEmpty(this.reservationData.reservation) ||
      this.reservationData.reservation.reservation_id !=
        this.activatedRoute.snapshot.paramMap.get("reservationID")
    ) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationListNoParam
      );
    }

    /* RESET RECEIPT NAME*/
    this.receiptFormUnder = this.formBuilder.group({
      name: [
        this.reservationData.userData.sei + this.reservationData.userData.mei,
        Validators.required,
      ],
      proviso: ["高速バス代金", Validators.required],
    });

    /* CALCULATE ALIGHTING DAY */
    this.reservationData.reservation.alightingDay =
      this.reservationData.reservation.dpt_ymd;

    if (this.reservationData.reservation.station_list) {
      let firstTime =
        this.reservationData.reservation.station_list[0].station_time;
      firstTime = parseInt(firstTime.replace(":", ""));

      let lastTime =
        this.reservationData.reservation.station_list[1].station_time;
      lastTime = parseInt(lastTime.replace(":", ""));

      if (firstTime > lastTime) {
        this.reservationData.reservation.alightingDay = this.moment(
          this.reservationData.reservation.alightingDay
        )
          .add(1, "days")
          .format("YYYY-MM-DD");
      }
    }

    /* CALCULATE PASSENGER */
    this.reservationData.reservation.passenger = {
      adult: {
        men: 0,
        women: 0,
        total: 0,
      },
      children: {
        men: 0,
        women: 0,
        total: 0,
      },
    };
    for (let passenger of this.reservationData.reservation.passenger_list) {

      if(passenger.board === 2) { continue; }
      if (
        passenger.price_type ==
        this.commonService.appConfig.reservation.priceType.adult
      ) {
        /* ADULT */
        if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          this.reservationData.reservation.passenger.adult.men++;
        } else if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexFemale
        ) {
          this.reservationData.reservation.passenger.adult.women++;
        }
      } else if (
        passenger.price_type ==
        this.commonService.appConfig.reservation.priceType.children
      ) {
        /* CHILDREN */
        if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexMale
        ) {
          this.reservationData.reservation.passenger.children.men++;
        } else if (
          passenger.sex ==
          this.commonService.appConfig.reservation.defaultUserData.sexFemale
        ) {
          this.reservationData.reservation.passenger.children.women++;
        }
      }
    }
    this.reservationData.reservation.passenger.adult.total =
      this.reservationData.reservation.passenger.adult.men +
      this.reservationData.reservation.passenger.adult.women;
    this.reservationData.reservation.passenger.children.total =
      this.reservationData.reservation.passenger.children.men +
      this.reservationData.reservation.passenger.children.women;
    /* END */

    /* SET CURRENT ITEM & LAST ITEM OF CANCEL LIST */
    let firstItem = this.reservationData.reservation.bus_detail.cancel_list[0];
    if (firstItem && firstItem.price) {
      this.currentCancelRuleItem = {
        ...firstItem,
        rate: `${firstItem.price}円`,
      };
    } else {
      this.currentCancelRuleItem = { id: 0, name: "無し", rate: 0 };
    }
    this.reservationData.reservation.cancelList = {
      firstItem: firstItem,
      lastItem:
        this.reservationData.reservation.bus_detail.cancel_list[
          this.reservationData.reservation.bus_detail.cancel_list.length - 1
        ],
    };

    /* THE DAY BEFORE DEPARTURE DAY */
    this.reservationData.reservation.dayBeforeDepartureDay = this.moment(
      this.reservationData.reservation.dpt_ymd
    )
      .startOf("day")
      .diff(this.moment(Date.now()).startOf("day"), "days");

    /* CHECK CHANGEABLE */
    let cancelDeadlineTime = this.moment(
      this.reservationData.reservation.dpt_ymd,
      "YYYY/MM/DD"
    )
      .subtract(this.reservationData.reservation.bus_detail.c_close_day, "days")
      .add(this.reservationData.reservation.bus_detail.c_close_hour, "hours")
      .valueOf();

    let currentServerTime = this.moment(
      this.moment()
        .utc()
        .add(this.appConfig.server.timeZoneOffset, "hours")
        .format("YYYY-MM-DD HH:mm:ss")
    ).valueOf();

    this.reservationData.reservation.changeable =
      this.reservationData.reservation.reservation_id &&
      this.reservationData.reservation.booking_status !==
        this.commonService.appConfig.reservation.bookingStatus.cancelled &&
      cancelDeadlineTime > currentServerTime
        ? true
        : false;
    /* END */

    /* CLEAR TEMP CACHES */
    this.commonService.removeData(
      this.commonService.appConfig.reservation.changeReservationDataSessionName
    );
    this.commonService.removeData("onSubmitReservationChanging");

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  setActivatedStation(station: any = {}) {
    this.activatedStation = station;
  }

  setCurrentCancelRuleItem(item: any) {
    if (this.currentCancelRuleItem.to != item.from) {
      this.currentCancelRuleItem = item;
    }
    return true;
  }

  async getCancelInformation() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("処理中・・・");

    let boardUser = "";
    for (let item of this.reservationData.reservation.passenger_list) {
      boardUser += "2|";
    }
    boardUser = boardUser.substr(0, boardUser.length - 1);

    let postCancelInformationData = {
      cancel_type: this.currentCancelRuleItem.id,
      reservation_id: this.reservationData.reservation.reservation_id,
      change_board: boardUser,
      auth_token: this.reservationData.reservation.auth_token,
    };

    this.cancelInformation = await this.reservationService.getCancelInformation(
      postCancelInformationData
    );

    if (!this._.isEmpty(this.cancelInformation)) {
      /* SHOW CANCEL MODAL */
      this.$("#mdl-cancel").modal();
    }

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  async submitCancel() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("処理中・・・");

    let changeData = this.reservationService.makeReservationChangeData(
      this.reservationData,
      {},
      true
    );

    let returnedData: any = await this.reservationService.changeReservation(
      changeData
    );

    if (returnedData.status == "success") {
      /* SHOW FINISH MODAL */
      this.$("#mdl-cancel").modal("hide");
      this.$("#mdl-cancel-finish").modal();
    } else {
      this.tempData.cancelErrorMessage = returnedData.data;
      this.tempData.changeErrorMessage = returnedData.message;
    }

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  /* REDIRECT */
  async finishCancel() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET RESERVATION DATA */
    let searchParams = this.commonService.getData("searchReservationParams");
    if (!this._.isEmpty(searchParams)) {
      /* FROM PUBLIC SEARCH */
      /* RELOAD RESERVATION */
      let reservationData: any =
        await this.reservationService.findReservationByID(
          this.commonService.getData("searchReservationParams")
        );

      if (!this._.isEmpty(reservationData.reservation)) {
        this.commonService.closeAllModals();
        window.location.reload();
      } else {
        /* CLEAR ALL CACHES */
        this.commonService.removeData("searchReservationParams");
        this.commonService.removeData("searchReservationDataEmail");
        this.commonService.removeData("searchReservationDataEmail");

        this.commonService.closeAllModals();
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageHomeNoParam
        );
      }
    } else {
      this.commonService.closeAllModals();
      this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReservationListNoParam
      );
    }
  }

  setReceiptPrice(price: any, reservationSlipId: any) {
    if (price) {
      if (price >= this.appConfig.reservation.receiptPriceLimit) {
        this.useUnderPrice = false;
      } else {
        this.useUnderPrice = true;
      }
      this.receiptData.price = parseInt(price);
    } else {
      this.receiptData.price = 0;
    }

    if (reservationSlipId) {
      this.receiptData.reservation_slip_id = reservationSlipId;
      this.pdfData.id = reservationSlipId;
      this.pdfData.reservationId =
        this.reservationData.reservation.reservation_id;
    }
  }

  createPDF() {
    this.tempData.formSubmitted = true;
    /* CHECK VALIDATORS */
    if (this.receiptFormUnder.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error-msg:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop:
              this.$(".form-error-msg:visible").first().offset().top - 90,
          },
          200
        );
      }
      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();
      return false;
    }

    //SET PDF DATA
    this.pdfData.name = this.receiptFormUnder.value.name;
    this.pdfData.proviso = this.receiptFormUnder.value.proviso;

    if (!this.authService.isLoggedIn()) {
      let authToken = this.reservationData.reservation.auth_token;
      let customerId = this.reservationData.userData.customer_id;
      this.pdfData.authToken = authToken;
      this.pdfData.customerId = customerId;
    } else {
      let authToken = this.reservationData.reservation.auth_token;
      let customerId = this.reservationData.userData.customer_id;
      let userData = JSON.parse(
        localStorage.getItem(this.appConfig.auth.loginSessionName)
      );
      let token = userData.token;
      this.pdfData.token = token;
      this.pdfData.authToken = authToken;
      this.pdfData.customerId = customerId;
    }
    //END
    this.reservationService.generatePDF(this.pdfData);
  }

  inlineJS() {
    let self = this;
  }
}
